import { useEffect, useState } from "react";
import { getCookie } from "../helperFunctions/cookie";
import { getSingleList } from "../api-interactions/lists";
import { getFamily } from "../api-interactions/family";
import { BsPlusCircleFill } from "react-icons/bs";

export const TaskManagmentTodoList = (props) => {
  const [data, setData] = useState({
    member: { userName: "..." },
    list: { open: [], accepted: [], denied: [] },
  });
  const user = JSON.parse(localStorage.getItem("user"));

  const getAcceptList = async () => {
    const members = await getFamily(user);
    const member = members[props.selected];
    const res = await getSingleList(getCookie(), member.todoLink);
    const todoList = res.data.list;
    console.log(todoList.needAccept, user.userName);
    const open = todoList.needAccept.filter(
      (item) => item.state === "open" && item.addedBy === user.userName
    );
    const accepted = todoList.needAccept.filter(
      (item) => item.state === "accepted" && item.addedBy === user.userName
    );
    const denied = todoList.needAccept.filter(
      (item) => item.state === "denied" && item.addedBy === user.userName
    );

    setData({
      member,
      list: {
        raw: todoList,
        open: open,
        accepted: accepted,
        denied: denied,
      },
    });
  };

  useEffect(() => {
    getAcceptList();
  }, [props.selected]);

  return (
    <div id="proposed-todo-container">
      <h2>{data.member.userName}</h2>
      <BsPlusCircleFill
        onClick={() => props.setQuickAdd(data.list.raw)}
        className="add-btn"
        style={{ marginRight: "2rem" }}
      />
      <div id="proposed-todo-items-container">
        <div id="proposed-todo-open">
          <strong className="open-count bigger">OPEN</strong>
          <div>
            {data.list.open.map((item) => {
              return (
                <div className="proposed-item-container">
                  <p>{item.name} - </p>
                  <p>{item.pointComplete} points</p>
                  {item.link && (
                    <a href={"/dashboard/lists/" + item.link}> - list</a>
                  )}
                </div>
              );
            })}
          </div>
        </div>
        <div id="proposed-todo-accepted">
          <strong className="accepted-count bigger">ACCEPTED</strong>
          <div>
            {data.list.accepted.map((item) => {
              return (
                <div className="proposed-item-container">
                  <p>{item.name} - </p>
                  <p>{item.pointComplete} points</p>
                  {item.link && (
                    <a href={"/dashboard/lists/" + item.link}> - list</a>
                  )}
                </div>
              );
            })}
          </div>
        </div>
        <div id="proposed-todo-denied">
          <strong className="denied-count bigger">DENIED</strong>
          <div>
            {data.list.denied.map((item) => {
              return (
                <div className="proposed-item-container">
                  <p>{item.name} - </p>
                  <p>{item.pointComplete} points</p>
                  {item.link && (
                    <a href={"/dashboard/lists/" + item.link}> - list</a>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
